import OnboardingContentWrapper from './OnboardingContentWrapper';

export default OnboardingContentWrapper;
